import { UpsellProductRulesDto } from "@intelligems/ig-types/dtos/upsell-product-rules";
import { CartTargetingFe } from "@intelligems/ig-types/fe-only/cart-targeting";
import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { replaceCartTargeting } from "@src/store/slices/cartTargeting";
import {
  getUpsellProductRules,
  setUpsellProductRulesByCheckoutBlockId,
} from "@src/store/slices/upsellProductRules";

/**
 * Replaces a block's upsell product rules, keeping each rule's `when` in sync
 * with the `cartTargeting` slice the way Save reads it — same pairing
 * `addUpsellProductRule` keeps for a single new rule. Ellie's
 * `setUpsellProductRules` tool goes through this so it can't drift from the
 * editor's rule/cartTargeting contract.
 */
export const replaceUpsellProductRules = createAsyncThunk<
  void,
  { checkoutBlockId: string; rules: UpsellProductRulesDto[] }
>(
  "upsellProductRules/replaceByCheckoutBlockId",
  ({ checkoutBlockId, rules }, { dispatch, getState }) => {
    const previousRules = getUpsellProductRules(getState()).filter(
      (rule) => rule.checkoutBlockId === checkoutBlockId
    );

    dispatch(
      replaceCartTargeting({
        cartTargetingIdsToRemove: previousRules.map(
          (rule) => rule.cartTargeting.id
        ),
        // Same cast `updateCartTargeting` applies to a compiled expression:
        // the Fe type requires `query` on every node.
        cartTargeting: rules.map(
          (rule) => rule.cartTargeting as CartTargetingFe
        ),
      })
    );
    dispatch(
      setUpsellProductRulesByCheckoutBlockId({ checkoutBlockId, rules })
    );
  }
);
